import React from "react";
import Skeleton from "react-loading-skeleton";

function MesOffresSkeleton() {
	return (
		<div className="col-md-12 as-col-table-container">
			<table className="table table-striped">
				<thead>
					<tr>
						<th
							scope="col"
							style={{ color: "#0C0B0B" }}
						>
							Date
						</th>
						<th
							scope="col"
							style={{ color: "#0C0B0B" }}
						>
							Produit achetés
						</th>
						<th
							scope="col"
							style={{ color: "#0C0B0B" }}
						>
							Montant
						</th>
						<th
							scope="col"
							style={{ color: "#0C0B0B" }}
						>
							Discount
						</th>
						<th
							scope="col"
							style={{ color: "#0C0B0B" }}
						>
							Points
						</th>
						<th
							scope="col"
							style={{ color: "#0C0B0B" }}
						>
							Actions
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th scope="row">
							<Skeleton />
						</th>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
					</tr>
					<tr>
						<th scope="row">
							<Skeleton />
						</th>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
					</tr>
					<tr>
						<th scope="row">
							<Skeleton />
						</th>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
					</tr>
					<tr>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
						<td>
							<Skeleton />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
}

export default MesOffresSkeleton;
